<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="!isEdit
          ? [
              { title: 'スタッフ一覧', href: '/setting/staff', color: 'primary', disabled: false },
              { title: '新規作成', disabled: true },
            ]
          : [
              { title: 'スタッフ一覧', href: '/setting/staff', color: 'primary', disabled: false },
              { title: `${lastName} ${firstName}`, href: `/setting/staff/${$route.params.id}`, color: 'primary', disabled: false },
              { title: 'アカウント設定', disabled: true },
            ]"
      ></v-breadcrumbs>
    </div>
    <page-title value="スタッフアカウント設定"></page-title>

    <v-form v-model="valid" ref="form">
      <v-container class="pt-12">
        <v-row>
          <v-col cols="6" align-self="center">
            <div>区分*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              v-model="category"
              :items="categorySelectValues"
              item-title="text"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
              :rules="[required]"
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>姓*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="lastName"
              :rules="[required]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>名*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="firstName"
              :rules="[required]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>姓（カナ）*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="lastNameKana"
              :rules="[required, isKatakana]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>名（カナ）*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="firstNameKana"
              :rules="[required, isKatakana]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div class="d-flex align-center">
              スタッフID*
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ props }">
                  <v-icon small v-bind="props"
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span
                  >＠をアルファベットの文字列で挟んだ形式で入力してください。</span
                ><br />
                <span
                  >例：［氏名のアルファベット表記］＠［施設名のアルファベット表記］</span
                ><br />
                <span>onamae@shisetumei</span><br />
                <span>※一度使用したスタッフIDは使用しないでください。</span
                ><br />
                <span>※個人のメールアドレスは登録しないでください。</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="email"
              :rules="[required, isEmail]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>生年月日*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="birth"
              variant="outlined"
              hide-details="auto"
              density="compact"
              type="date"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>性別*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="genderSelectValues"
              v-model="gender"
              :rules="[required]"
              item-title="text"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>住所</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="address"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>電話番号1</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="phoneNumber1"
              :rules="[isTel]"
              placeholder="ハイフン有り"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>電話番号2</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="phoneNumber2"
              :rules="[isTel]"
              placeholder="ハイフン有り"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="py-3">
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>施設長</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isDirector" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>主任</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isChief" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>
              管理者
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ props }">
                  <v-icon small v-bind="props"
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span>管理者権限は全ての項目の編集ができる権限です</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isAdmin" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>スタッフコード1</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="staffCode1"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>スタッフコード2</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="staffCode2"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>入社日*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="joinDate"
              variant="outlined"
              hide-details="auto"
              density="compact"
              type="date"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>配属日*</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="assignDate"
              variant="outlined"
              hide-details="auto"
              density="compact"
              type="date"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>退職日</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="retireDate"
              variant="outlined"
              hide-details="auto"
              density="compact"
              type="date"
              clearable
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>退職理由</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="retireSelectValues"
              v-model="retireReason"
              item-title="text"
              item-value="value"
              density="compact"
              variant="outlined"
              hide-details
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center"> </v-col>
          <v-col cols="6" align-self="center">
            <v-textarea
              v-model="retireReasonComment"
              variant="outlined"
              density="compact"
              hide-details
              label="理由詳細"
              color="primary"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>担任クラス</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="classes"
              v-model="classesInCharge"
              item-title="className"
              item-value="classId"
              variant="outlined"
              density="compact"
              hide-details
              multiple
              chips
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <div>備考</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-textarea v-model="comment" variant="outlined" label="備考" color="primary"> </v-textarea>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>非表示</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isHidden" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="3">
            <v-btn
              v-if="isEdit"
              @click="updateStaff"
              :loading="loading"
              color="primary"
              variant="flat"
              block
            >
              保存
            </v-btn>

            <v-btn
              v-else
              @click="createStaff"
              :loading="loading"
              :disabled="!valid"
              color="primary"
              variant="flat"
              block
            >
              登録
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script lang="ts">
import { staffModule } from "@/store/dataModules/staffModule";
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import { classModule } from "@/store/dataModules/classModule";
import { staffEditModule } from "@/store/dataModules/staffEditModule";
import LocalDataService from "@/service/LocalDataService";
import Swal from "sweetalert2";
import ValidationMixin from "@/mixins/ValidationMixin";

export default defineComponent({
  name: "StaffEdit",

  mixins: [ValidationMixin],

  components: {
    PageTitle,
  },

  mounted() {
    this.getStaff();
    this.listClass();

    if (this.$route.params.id == "new") {
      staffEditModule.clearValues();

      // reset validation
      (this.$refs.form as any).resetValidation();
    }
  },

  data() {
    return {
      valid: false,
      loading: false,
      retireSelectValues: [
        { text: "", value: "" },
        { text: "異動", value: "transfer" },
        { text: "退職", value: "retire" },
        { text: "死亡", value: "die" },
      ],
      categorySelectValues: [
        { text: "一般", value: "general" },
        { text: "ヘルプ", value: "help" },
      ],
      genderSelectValues: [
        { text: "", value: "" },
        { text: "男性", value: "male" },
        { text: "女性", value: "female" },
      ],
    };
  },

  computed: {
    classes: function (): any[] {
      return classModule.classes.map((c) => {
        return {
          className: `${c.year}年度 ${c.className}`,
          classId: c.classId,
        };
      });
    },
    userNurseryId: function () {
      staffEditModule.setUserId(this.$route.params.id as string);
      return this.$route.params.id;
    },
    isEdit: function (): boolean {
      return this.$route.params.id == "new" ? false : true;
    },
    category: {
      get() {
        return staffEditModule.category;
      },
      set(value: "general" | "help") {
        staffEditModule.setCategory(value);
      },
    },
    firstName: {
      get() {
        return staffEditModule.firstName;
      },
      set(value: string) {
        staffEditModule.setFirstName(value);
      },
    },
    lastName: {
      get() {
        return staffEditModule.lastName;
      },
      set(value: string) {
        staffEditModule.setLastName(value);
      },
    },
    firstNameKana: {
      get() {
        return staffEditModule.firstNameKana;
      },
      set(value: string) {
        staffEditModule.setFirstNameKana(value);
      },
    },
    lastNameKana: {
      get() {
        return staffEditModule.lastNameKana;
      },
      set(value: string) {
        staffEditModule.setLastNameKana(value);
      },
    },
    staffCode1: {
      get() {
        return staffEditModule.staffCode1;
      },
      set(value: string) {
        staffEditModule.setStaffCode1(value);
      },
    },
    staffCode2: {
      get() {
        return staffEditModule.staffCode2;
      },
      set(value: string) {
        staffEditModule.setStaffCode2(value);
      },
    },
    email: {
      get() {
        return staffEditModule.email;
      },
      set(value: string) {
        staffEditModule.setEmail(value);
      },
    },
    isDirector: {
      get() {
        return staffEditModule.isDirector;
      },
      set(value: boolean) {
        staffEditModule.setIsDirector(value);
      },
    },
    isChief: {
      get() {
        return staffEditModule.isChief;
      },
      set(value: boolean) {
        staffEditModule.setIsChief(value);
      },
    },
    isAdmin: {
      get() {
        return staffEditModule.isAdmin;
      },
      set(value: boolean) {
        staffEditModule.setIsAdmin(value);
      },
    },
    birth: {
      get() {
        return staffEditModule.birth;
      },
      set(value: string) {
        staffEditModule.setBirth(value);
      },
    },
    gender: {
      get() {
        return staffEditModule.gender;
      },
      set(value: string) {
        staffEditModule.setGender(value);
      },
    },
    address: {
      get() {
        return staffEditModule.address;
      },
      set(value: string) {
        staffEditModule.setAddress(value);
      },
    },
    phoneNumber1: {
      get() {
        return staffEditModule.phoneNumber1;
      },
      set(value: string) {
        staffEditModule.setPhoneNumber1(value);
      },
    },
    phoneNumber2: {
      get() {
        return staffEditModule.phoneNumber2;
      },
      set(value: string) {
        staffEditModule.setPhoneNumber2(value);
      },
    },
    joinDate: {
      get() {
        return staffEditModule.joinDate;
      },
      set(value: string) {
        staffEditModule.setJoinDate(value);
      },
    },
    assignDate: {
      get() {
        return staffEditModule.assignDate;
      },
      set(value: string) {
        staffEditModule.setAssignDate(value);
      },
    },
    retireDate: {
      get() {
        return staffEditModule.retireDate;
      },
      set(value: string) {
        staffEditModule.setRetireDate(value);
      },
    },
    retireReason: {
      get() {
        return staffEditModule.retireReason;
      },
      set(value: "transfer" | "retire" | "die") {
        staffEditModule.setRetireReason(value);
      },
    },
    retireReasonComment: {
      get() {
        return staffEditModule.retireReasonComment;
      },
      set(value: string) {
        staffEditModule.setRetireReasonComment(value);
      },
    },
    classesInCharge: {
      get() {
        return staffEditModule.classesInCharge;
      },
      set(value: number[]) {
        staffEditModule.setclassesInCharge(value);
      },
    },
    comment: {
      get() {
        return staffEditModule.comment;
      },
      set(value: string) {
        staffEditModule.setComment(value);
      },
    },
    isHidden: {
      get() {
        return staffEditModule.isHidden;
      },
      set(value: boolean) {
        staffEditModule.setIsHidden(value);
      },
    },
  },

  methods: {
    async getStaff() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.isEdit) {
        await staffModule.getStaff({
          nurseryId: String(nurseryId),
          userNurseryId: this.userNurseryId as string,
        });
        this.setValues();
      }
    },
    async createStaff() {
      this.loading = true;
      if (this.checkValidation()) {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          const response = await staffEditModule.createStaff({
            nurseryId: String(nurseryId),
          });
          if (response) {
            Swal.fire({ title: "作成しました", icon: "success" });
            this.$router.push({ path: "/setting/staff" });
          } else {
            Swal.fire({ title: "失敗しました", icon: "error" });
          }
        }
      }
      this.loading = false;
    },
    async updateStaff() {
      this.loading = true;
      if (this.checkValidation()) {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          const response = await staffEditModule
            .updateStaff({
              nurseryId: String(nurseryId),
            })
            .catch((e) => {
              return;
            });
          if (response) {
            Swal.fire({ title: "保存しました", icon: "success" });
            this.$router.push({ path: "/setting/staff" });
          } else {
            Swal.fire({
              title: "保存に失敗しました<br>以下の理由が考えられます",
              icon: "error",
              html: "・メールアドレスが他のユーザーと重複している<br>・不正な値の入力<br>・その他",
            });
          }
        }
      }
      this.loading = false;
    },
    async listClass() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId: nurseryId,
        });
      }
    },
    checkValidation(): boolean {
      if (this.birth && this.joinDate && this.assignDate && this.category) {
        return true;
      } else {
        Swal.fire({
          title: "エラー",
          text: "必須項目が入力されていません",
          icon: "warning",
        });
        return false;
      }
    },
    setValues() {
      if (staffModule.staffDetail) {
        staffEditModule.setCategory(staffModule.staffDetail.category);
        staffEditModule.setFirstName(staffModule.staffDetail.firstName);
        staffEditModule.setLastName(staffModule.staffDetail.lastName);
        staffEditModule.setFirstNameKana(staffModule.staffDetail.firstNameKana);
        staffEditModule.setLastNameKana(staffModule.staffDetail.lastNameKana);
        staffEditModule.setIsDirector(staffModule.staffDetail.isDirector);
        staffEditModule.setIsChief(staffModule.staffDetail.isChief);
        staffEditModule.setIsAdmin((staffModule.staffDetail as any).isAdmin);
        staffEditModule.setEmail(staffModule.staffDetail.email);
        staffEditModule.setStaffCode1(staffModule.staffDetail.staffCode1 || "");
        staffEditModule.setStaffCode2(staffModule.staffDetail.staffCode2 || "");
        staffEditModule.setBirth(staffModule.staffDetail.birth);
        staffEditModule.setGender(staffModule.staffDetail.gender);
        staffEditModule.setAddress(staffModule.staffDetail.address || "");
        staffEditModule.setPhoneNumber1(
          staffModule.staffDetail.phoneNumber1 || ""
        );
        staffEditModule.setPhoneNumber2(
          staffModule.staffDetail.phoneNumber2 || ""
        );
        staffEditModule.setJoinDate(staffModule.staffDetail.joinDate);
        staffEditModule.setAssignDate(staffModule.staffDetail.assignDate);
        staffEditModule.setclassesInCharge(
          staffModule.staffDetail.classesInCharge.map((c) => {
            return c.classId;
          })
        );
        staffEditModule.setComment(staffModule.staffDetail.comment || "");
        staffEditModule.setRetireDate(staffModule.staffDetail.retireDate || "");
        staffEditModule.setRetireReason(
          staffModule.staffDetail.retireReason || ""
        );
        staffEditModule.setRetireReasonComment(
          staffModule.staffDetail.retireReasonComment || ""
        );
        staffEditModule.setIsHidden((staffModule.staffDetail as any).isHidden);
      }
    },
  },
});
</script>
